import { useState } from 'react';

function ProceduresList({ procedures, roles, loading, error, onSelect, onCreate }) {
  const [filterCategory, setFilterCategory] = useState('');

  if (loading) return <p style={{ textAlign: 'center', color: '#999', padding: '2rem' }}>Loading procedures...</p>;

  const categories = [...new Set(procedures.map(p => p.category).filter(Boolean))].sort();
  const filtered = filterCategory
    ? procedures.filter(p => p.category === filterCategory)
    : procedures;

  function formatDate(iso) {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  return (
    <div className="ProcList">
      {error && <p className="Vault-error">{error}</p>}

      <div className="ProcList-top">
        <button className="ProcList-new-btn" onClick={onCreate}>+ New Procedure</button>
        {categories.length > 0 && (
          <select
            className="ProcList-filter"
            value={filterCategory}
            onChange={e => setFilterCategory(e.target.value)}
          >
            <option value="">All Categories</option>
            {categories.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        )}
      </div>

      {filtered.length === 0 && (
        <p style={{ textAlign: 'center', color: '#999', padding: '2rem' }}>
          {procedures.length === 0 ? 'No procedures yet. Create one to get started.' : 'No procedures in this category.'}
        </p>
      )}

      <div className="ProcList-items">
        {filtered.map(proc => {
          const role = roles.find(r => r.id === proc.roleTag);
          return (
            <button key={proc.id} className="ProcList-card" onClick={() => onSelect(proc)}>
              <div className="ProcList-card-top">
                {role && <span className="ProcList-card-dot" style={{ background: role.color }} />}
                <span className="ProcList-card-name">{proc.name}</span>
                <span className="ProcList-card-steps">{proc.steps.length} steps</span>
              </div>
              {proc.description && <p className="ProcList-card-desc">{proc.description}</p>}
              <div className="ProcList-card-meta">
                {proc.category && <span>{proc.category}</span>}
                <span>Modified {formatDate(proc.lastModified || proc.createdDate)}</span>
                {proc.conversionStatus === 'in_progress' && <span className="ProcList-card-converting">Converting...</span>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ProceduresList;
